module.exports = {"bewizr":{"login":"Log in with BeWizr"}}